import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS } from "../data/content";
import { scrollToId } from "../lib/scroll";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open ? "border-b border-cyan-500/15 bg-[#070B19]/85 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Back to top" data-testid="nav-logo-button">
          <Logo />
        </button>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-slate-400 transition-colors hover:text-cyan-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-quote-button"
            onClick={() => go("enquiry")}
            className="hidden rounded-full bg-gradient-to-r from-cyan-400 to-blue-600 px-5 py-2.5 text-sm font-semibold text-[#04101F] shadow-[0_0_24px_rgba(0,240,255,0.35)] transition-transform duration-200 hover:scale-[1.03] sm:block"
          >
            Get a quote
          </button>
          <button
            data-testid="nav-menu-toggle"
            className="rounded-lg border border-white/10 p-2 text-slate-300 lg:hidden"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-cyan-500/10 bg-[#070B19]/95 backdrop-blur-xl lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1 px-5 py-4">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="rounded-lg px-3 py-3 text-left text-sm font-medium text-slate-300 hover:bg-white/5 hover:text-cyan-300"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-quote-button"
              onClick={() => go("enquiry")}
              className="mt-2 rounded-full bg-gradient-to-r from-cyan-400 to-blue-600 px-5 py-3 text-sm font-semibold text-[#04101F]"
            >
              Get a quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
